import { ModalWrapper } from './ModalWrapper.tsx'

export const CookieModal = ({ showModal, onClose }: ModalProps) => {
  return (
    <>
      <ModalWrapper showModal={showModal} onClose={onClose}>
        <div className="flex flex-col p-4">
          <h1>Cookie modal</h1>
        </div>
      </ModalWrapper>
    </>
  )
}
